<template>
  <div class="login">
    <div class="login__content">
      <div class="login__header">
        <div class="login__font-sizes">
          <manage-fonts />
        </div>
        <div class="login__idioms">
          <idioms />
        </div>
      </div>
      <div class="login__body">
        <transition
          name="default-opacity-transition"
          mode="out-in"
        >
          <router-view class="login__body-content"></router-view>
        </transition>
      </div>
      <div class="login__footer">
        <a
          href="http://treetech.com.br/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="login__powered-by-label">
            Powered by Treetech Tecnologia
          </span>
          <i
            aria-hidden="true"
            class="fas fa-external-link-alt login__powered-by-icon"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ManageFonts from '@/domain/components/login/ManageFonts';
import Idioms from '@/domain/components/login/Idioms';

export default {
  components: {
    ManageFonts,
    Idioms,
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"
@import "src/styles/defaults/variables"

.login
  background-image: url("/static/imgs/login-background.png")
  background-attachment: fixed
  background-position: center
  background-repeat: no-repeat
  background-size: cover
  min-height: 100%
  display: flex
  flex-direction: column
  overflow: hidden
  &__body
    max-height: 70%
  &__content
    overflow: auto
    flex: 1
    display: flex
    flex-direction: column
    justify-content: space-between
    align-items: center
    min-height: 100%
  &__header
    display: flex
    flex-direction: column
    align-items: center
    padding: 10px 30px
    min-height: 3.5em
    width: 100%
    > :not(:first-child)
      margin-top: 10px
  &__idioms
    color: $color-white-100
    font-size: .8em
  &__body-content
    border-radius: 3px
    margin-top: 5px
    margin-bottom: 10px
  &__footer
    display: flex
    flex-direction: column
    align-items: center
    font-size: .8rem
    text-decoration: underline
    text-align: center
    color: $color-white-100
    padding: 10px 30px
  &__powered-by-icon
    margin-left: 5px
  +media-min-sm()
    &__header
      flex-direction: row
      justify-content: space-between
      align-items: flex-start
      min-height: 2em
      > :not(:first-child)
        margin-top: 0
  +media-min-md()
  +media-min-lg()
</style>
